import { getAuth } from 'firebase/auth';
import { toast } from 'react-toastify';
import { getBaseApiUrl } from 'src/config/apiConfig';
import { HttpClient, HttpError } from 'switch-fe-shared/utils/http.service';

/**
 * Pre-configured HttpClient instance for admin-console.
 * - Uses Firebase authentication
 * - Shows toast notifications on errors
 * - Has retry logic for server errors
 */
export const apiClient = new HttpClient({
  baseURL: getBaseApiUrl(),
  retries: 2,
  retryDelay: 1000,
  getAuthToken: async () => {
    return (await getAuth()?.currentUser?.getIdToken?.()) ?? null;
  },
  onError: (error: HttpError) => {
    toast.error(error.message ?? 'An error occurred', {
      autoClose: 10000,
    });
  },
  onRetry: (attempt, maxAttempts) => {
    toast.info(`Request failed, retrying (${attempt}/${maxAttempts})...`, {
      autoClose: 2000,
    });
  },
});

export interface ResultWithValueAndHttpCode<T> {
  isSuccess: boolean;
  value: T | null;
  errorMessage: string;
  httpCode: number;
}

export interface ResultWithHttpCode {
  isSuccess: boolean;
  errorMessage: string;
  httpCode: number;
}

// Re-export for convenience
export {
  HttpClientError,
  HttpNetworkError,
  HttpServerError,
  HttpTimeoutError,
} from 'switch-fe-shared/utils/http.errors';
export { HttpClient, HttpError } from 'switch-fe-shared/utils/http.service';

export default apiClient;
